const NOTETAKER_STAR_GRADIENT_ID = 'notetaker-star-gradient'
const NOTETAKER_CAMERA_PATH = [
  'M2.59998 0C2.01651 0 1.45693 0.231785 1.04435 0.644365C0.631768 1.05695 ',
  '0.399983 1.61652 0.399983 2.2V5.72693C0.399983 5.72693 0.399983 6.25659 1.04435 ',
  '6.25659C1.59998 6.25659 1.59998 5.72693 1.59998 5.72693V2.2C1.59998 1.93478 1.70534 ',
  '1.68043 1.89288 1.49289C2.08041 1.30536 2.33477 1.2 2.59998 1.2H10.1072C10.3724 1.2 ',
  '10.6268 1.30536 10.8143 1.49289C11.0018 1.68043 11.1072 1.93478 11.1072 2.2V4.1696C11.1072 ',
  '4.38036 11.2178 4.57567 11.3985 4.6841C11.5792 4.79253 11.8036 4.79819 11.9896 4.699L14.5064 ',
  '3.3566C14.5367 3.34051 14.5707 3.33252 14.6051 3.3334C14.6396 3.33428 14.6733 3.34408 14.7029 ',
  '3.36183C14.7325 3.37959 14.757 3.40471 14.774 3.43474C14.791 3.46477 14.8 3.49869 14.8 3.5332V8.8668',
  'C14.8 8.90131 14.791 8.93524 14.774 8.96527C14.757 8.99529 14.7325 9.02041 14.7029 9.03817C14.6733 ',
  '9.05592 14.6396 9.06572 14.6051 9.0666C14.5707 9.06748 14.5364 9.05933 14.506 9.0432L11.9896 7.701',
  'C11.8036 7.60181 11.5792 7.60747 11.3985 7.7159C11.2178 7.82433 11.1072 8.01964 11.1072 8.2304V10.2',
  'C11.1072 10.4652 11.0018 10.7196 10.8143 10.9071C10.6268 11.0946 10.3724 11.2 10.1072 11.2L9.28421 11.1992',
  'C9.28421 11.1992 8.78421 11.2 8.78421 11.7556C8.78421 12.3113 9.28421 12.4 9.28421 12.4H10.1072C10.6907 12.4 ',
  '11.2502 12.1682 11.6628 11.7556C12.0754 11.3431 12.3072 10.7835 12.3072 10.2V9.23044L13.942 10.1024C14.1552 ',
  '10.216 14.3942 10.2724 14.6358 10.2662C14.8773 10.26 15.1131 10.1915 15.3203 10.0672C15.5274 9.94285 15.6989 9.76705 ',
  '15.818 9.55685C15.9371 9.34665 15.9998 9.1088 16 8.8672V3.5324C15.9998 3.2908 15.9371 3.05335 15.818 2.84315 ',
  '15.6989 2.63295 15.5274 2.45715 15.3203 2.33284C15.1131 2.20854 14.8773 2.13997 14.6358 2.13379C14.3942 2.12762 ',
  '14.1549 2.18424 13.9416 2.2978L12.3072 3.16956V2.2C12.3072 1.61652 12.0754 1.05695 11.6628 0.644365C11.2502 0.231785 ',
  '10.6907 0 10.1072 0H2.59998Z',
].join('')
const NOTETAKER_STAR_PATH = [
  'M3.473 6.56613C3.65403 6.07691 4.34597 6.07691 4.527 6.56613L5.27626 8.59097C5.33317 8.74478 5.45444 8.86605 5.60825 8.92296',
  'L7.63309 9.67222C8.1223 9.85325 8.1223 10.5452 7.63309 10.7262L5.60825 11.4755C5.45444 11.5324 5.33317 11.6537 5.27626 11.8075',
  'L4.527 13.8323C4.34597 14.3215 3.65403 14.3215 3.473 13.8323L2.72374 11.8075C2.66683 11.6537 2.54556 11.5324 2.39175 11.4755',
  'L0.366913 10.7262C-0.122304 10.5452 -0.122304 9.85325 0.366913 9.67222L2.39175 8.92296',
  'C2.54556 8.86605 2.66683 8.74478 2.72374 8.59097L3.473 6.56613Z',
].join('')

export const NotetakerToggleIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d={NOTETAKER_CAMERA_PATH} fill="#0B3558" />
    <path d={NOTETAKER_STAR_PATH} fill={`url(#${NOTETAKER_STAR_GRADIENT_ID})`} />
    <defs>
      <linearGradient
        id={NOTETAKER_STAR_GRADIENT_ID}
        x1="5.33355e-08"
        y1="4.73328e-08"
        x2="14.0986"
        y2="15.8866"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D73D4A" />
        <stop offset="0.5" stopColor="#8B61FF" />
        <stop offset="1" stopColor="#006BFF" />
      </linearGradient>
    </defs>
  </svg>
)
